'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, Drawer, Modal as RedesignModal } from '@systemeio/components';
import { XCloseIcon } from '@systemeio/icons';
import type { ReactElement, ReactNode } from 'react';
import useMediaQuery from 'shared/hooks/use-media-query';
type ModalPopupProps = Omit<RedesignModal.Popup.Props, 'children' | 'render' | 'size'>;
interface ModalProps {
  title: ReactNode;
  opened: boolean;
  onClose: () => void;
  children?: ReactNode;
  headerContent?: ReactNode;
  footer?: ReactNode;
  render?: ReactElement;
  isFetching?: boolean;
  size?: RedesignModal.Popup.Size;
  afterLeave?: () => void;
  afterEnter?: () => void;
  'data-test'?: string;
  popupProps?: ModalPopupProps;
}
function Modal(t0) {
  const $ = _c(85);
  const {
    title,
    opened,
    onClose,
    children,
    headerContent,
    footer,
    render,
    isFetching: t1,
    size,
    afterLeave,
    afterEnter,
    "data-test": dataTest,
    popupProps
  } = t0;
  const isFetching = t1 === undefined ? false : t1;
  const {
    isMobile
  } = useMediaQuery();
  let t2;
  if ($[0] !== popupProps) {
    t2 = popupProps ?? {};
    $[0] = popupProps;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let popupBackdropProps;
  let popupClassName;
  let popupCloseProps;
  let restPopupProps;
  if ($[2] !== t2) {
    ({
      backdropProps: popupBackdropProps,
      className: popupClassName,
      closeProps: popupCloseProps,
      ...restPopupProps
    } = t2);
    $[2] = t2;
    $[3] = popupBackdropProps;
    $[4] = popupClassName;
    $[5] = popupCloseProps;
    $[6] = restPopupProps;
  } else {
    popupBackdropProps = $[3];
    popupClassName = $[4];
    popupCloseProps = $[5];
    restPopupProps = $[6];
  }
  if (isMobile) {
    let t3;
    if ($[7] !== isFetching || $[8] !== onClose) {
      t3 = (open, eventDetails) => {
        if (open) {
          return;
        }
        if (isFetching) {
          eventDetails.cancel();
          return;
        }
        onClose();
      };
      $[7] = isFetching;
      $[8] = onClose;
      $[9] = t3;
    } else {
      t3 = $[9];
    }
    let t4;
    if ($[10] !== afterEnter || $[11] !== afterLeave) {
      t4 = open_0 => {
        if (open_0) {
          afterEnter?.();
        } else {
          afterLeave?.();
        }
      };
      $[10] = afterEnter;
      $[11] = afterLeave;
      $[12] = t4;
    } else {
      t4 = $[12];
    }
    let t5;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = {
        forceRender: true
      };
      $[13] = t5;
    } else {
      t5 = $[13];
    }
    let t6;
    if ($[14] !== title) {
      t6 = <Drawer.Title>{title}</Drawer.Title>;
      $[14] = title;
      $[15] = t6;
    } else {
      t6 = $[15];
    }
    let t7;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = <XCloseIcon />;
      $[16] = t7;
    } else {
      t7 = $[16];
    }
    let t8;
    if ($[17] !== isFetching) {
      t8 = <Drawer.Close aria-label="Close" render={<Button disabled={isFetching} type="button" size="icon-sm" variant="ghost-gray">{t7}</Button>} />;
      $[17] = isFetching;
      $[18] = t8;
    } else {
      t8 = $[18];
    }
    let t9;
    if ($[19] !== t6 || $[20] !== t8) {
      t9 = <Drawer.Header className="flex-row items-center justify-between gap-2.5">{t6}{t8}</Drawer.Header>;
      $[19] = t6;
      $[20] = t8;
      $[21] = t9;
    } else {
      t9 = $[21];
    }
    let t10;
    if ($[22] !== children || $[23] !== headerContent) {
      t10 = headerContent ? <div className="flex min-h-0 flex-1 flex-col gap-4">{headerContent}{children}</div> : children;
      $[22] = children;
      $[23] = headerContent;
      $[24] = t10;
    } else {
      t10 = $[24];
    }
    let t11;
    if ($[25] !== t10) {
      t11 = <Drawer.Content className="p-4 [--sticky-top:--spacing(-4)]">{t10}</Drawer.Content>;
      $[25] = t10;
      $[26] = t11;
    } else {
      t11 = $[26];
    }
    let t12;
    if ($[27] !== footer) {
      t12 = footer && <Drawer.Footer className="gap-3 [&>*]:flex-1">{footer}</Drawer.Footer>;
      $[27] = footer;
      $[28] = t12;
    } else {
      t12 = $[28];
    }
    let t13;
    if ($[29] !== dataTest || $[30] !== render || $[31] !== t11 || $[32] !== t12 || $[33] !== t9) {
      t13 = <Drawer.Popup backdropProps={t5} data-test={dataTest} render={render}>{t9}{t11}{t12}</Drawer.Popup>;
      $[29] = dataTest;
      $[30] = render;
      $[31] = t11;
      $[32] = t12;
      $[33] = t9;
      $[34] = t13;
    } else {
      t13 = $[34];
    }
    let t14;
    if ($[35] !== opened || $[36] !== t13 || $[37] !== t3 || $[38] !== t4) {
      t14 = <Drawer.Root open={opened} onOpenChange={t3} onOpenChangeComplete={t4}>{t13}</Drawer.Root>;
      $[35] = opened;
      $[36] = t13;
      $[37] = t3;
      $[38] = t4;
      $[39] = t14;
    } else {
      t14 = $[39];
    }
    return t14;
  }
  let t3;
  if ($[40] !== title) {
    t3 = <RedesignModal.Title>{title}</RedesignModal.Title>;
    $[40] = title;
    $[41] = t3;
  } else {
    t3 = $[41];
  }
  let t4;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <XCloseIcon />;
    $[42] = t4;
  } else {
    t4 = $[42];
  }
  let t5;
  if ($[43] !== isFetching) {
    t5 = <RedesignModal.Close render={<Button disabled={isFetching} type="button" size="icon-sm" variant="ghost-gray">{t4}</Button>} />;
    $[43] = isFetching;
    $[44] = t5;
  } else {
    t5 = $[44];
  }
  let t6;
  if ($[45] !== t3 || $[46] !== t5) {
    t6 = <>{t3}{t5}</>;
    $[45] = t3;
    $[46] = t5;
    $[47] = t6;
  } else {
    t6 = $[47];
  }
  const modalHeader = t6;
  let t7;
  if ($[48] !== isFetching || $[49] !== onClose) {
    t7 = (open_1, eventDetails_0) => {
      if (open_1) {
        return;
      }
      if (isFetching) {
        eventDetails_0.cancel();
        return;
      }
      onClose();
    };
    $[48] = isFetching;
    $[49] = onClose;
    $[50] = t7;
  } else {
    t7 = $[50];
  }
  let t8;
  if ($[51] !== afterEnter || $[52] !== afterLeave) {
    t8 = open_2 => {
      if (open_2) {
        afterEnter?.();
      } else {
        afterLeave?.();
      }
    };
    $[51] = afterEnter;
    $[52] = afterLeave;
    $[53] = t8;
  } else {
    t8 = $[53];
  }
  let t9;
  if ($[54] !== popupBackdropProps) {
    t9 = {
      forceRender: true,
      ...popupBackdropProps
    };
    $[54] = popupBackdropProps;
    $[55] = t9;
  } else {
    t9 = $[55];
  }
  const t10 = isFetching || Boolean(popupCloseProps?.disabled);
  let t11;
  if ($[56] !== popupCloseProps || $[57] !== t10) {
    t11 = {
      "aria-label": "Close",
      ...popupCloseProps,
      disabled: t10
    };
    $[56] = popupCloseProps;
    $[57] = t10;
    $[58] = t11;
  } else {
    t11 = $[58];
  }
  const t12 = headerContent ? "flex shrink-0 flex-col items-stretch gap-2.5" : "flex shrink-0 justify-between gap-2.5";
  let t13;
  if ($[59] !== headerContent || $[60] !== modalHeader) {
    t13 = headerContent ? <><div className="flex items-center justify-between gap-2.5">{modalHeader}</div>{headerContent}</> : modalHeader;
    $[59] = headerContent;
    $[60] = modalHeader;
    $[61] = t13;
  } else {
    t13 = $[61];
  }
  let t14;
  if ($[62] !== t12 || $[63] !== t13) {
    t14 = <RedesignModal.Header className={t12}>{t13}</RedesignModal.Header>;
    $[62] = t12;
    $[63] = t13;
    $[64] = t14;
  } else {
    t14 = $[64];
  }
  let t15;
  if ($[65] !== children) {
    t15 = <div className="flex min-h-0 flex-1 flex-col overflow-y-auto px-8 py-6 [--sticky-top:--spacing(-6)]">{children}</div>;
    $[65] = children;
    $[66] = t15;
  } else {
    t15 = $[66];
  }
  let t16;
  if ($[67] !== footer) {
    t16 = footer && <RedesignModal.Footer className="[&>*]:flex-none">{footer}</RedesignModal.Footer>;
    $[67] = footer;
    $[68] = t16;
  } else {
    t16 = $[68];
  }
  let t17;
  if ($[69] !== dataTest || $[70] !== popupClassName || $[71] !== render || $[72] !== restPopupProps || $[73] !== size || $[74] !== t11 || $[75] !== t14 || $[76] !== t15 || $[77] !== t16 || $[78] !== t9) {
    t17 = <RedesignModal.Popup {...restPopupProps} backdropProps={t9} render={render} closeProps={t11} data-test={dataTest} size={size} className={popupClassName}>{t14}{t15}{t16}</RedesignModal.Popup>;
    $[69] = dataTest;
    $[70] = popupClassName;
    $[71] = render;
    $[72] = restPopupProps;
    $[73] = size;
    $[74] = t11;
    $[75] = t14;
    $[76] = t15;
    $[77] = t16;
    $[78] = t9;
    $[79] = t17;
  } else {
    t17 = $[79];
  }
  let t18;
  if ($[80] !== opened || $[81] !== t17 || $[82] !== t7 || $[83] !== t8) {
    t18 = <RedesignModal.Root open={opened} onOpenChange={t7} onOpenChangeComplete={t8}>{t17}</RedesignModal.Root>;
    $[80] = opened;
    $[81] = t17;
    $[82] = t7;
    $[83] = t8;
    $[84] = t18;
  } else {
    t18 = $[84];
  }
  return t18;
}
export { Modal };
export type { ModalProps };